import Vue from 'vue';

export default {
    getJobEvents(context) {
        const url = 'v1/me/job-events';
        return Vue.$axios.$get(url).then((response) => {
            context.commit('STORE_JOB_EVENTS', response);
            return response;
        });
    },
};
